export default (tabs, isEnabled, permissions) => {
  const hasAccess = permission =>
    Array.isArray(permission)
      ? permission.some(required => permissions.includes(required))
      : permissions.includes(permission);

  return tabs.filter(tab => {
    const flagEnabled = tab.featureFlag ? isEnabled(tab.featureFlag) : true;
    const permissionEnabled = tab.permission ? hasAccess(tab.permission) : true;
    return flagEnabled && permissionEnabled;
  });
};
